import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/login" />
          </IonButtons>
          <IonTitle>{t('pages.TermsOfService.termsOfService')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <h2>{t('pages.TermsOfService.termsOfService')}</h2>
        <p style={{ color: '#888', fontSize: '0.85rem' }}>{t('pages.TermsOfService.lastUpdatedApril22026')}</p>

        <p>{t('pages.TermsOfService.byUsingTheRSMaids')}</p>

        <h3>{t('pages.TermsOfService.1AuthorizedUse')}</h3>
        <p>{t('pages.TermsOfService.thisApplicationIsProvidedExclusivelyFor')}</p>

        <h3>{t('pages.TermsOfService.2GoogleCalendarIntegration')}</h3>
        <p>{t('pages.TermsOfService.byConnectingYourGoogleAccountYou')}</p>

        <h3>{t('pages.TermsOfService.3AcceptableUse')}</h3>
        <p>{t('pages.TermsOfService.youAgreeToUseTheService')}</p>

        <h3>{t('pages.TermsOfService.4Termination')}</h3>
        <p>{t('pages.TermsOfService.accessToTheServiceMayBe')}</p>

        <h3>{t('pages.TermsOfService.5Contact')}</h3>
        <p>{t('pages.TermsOfService.questionsEmailUsAt')} <strong>{t('pages.TermsOfService.supportRsmaidsserviceNet')}</strong></p>
      </IonContent>
    </IonPage>
  );
};

export default TermsOfService;
